// The manual-upload workflow supports exactly these two extensions (see
// app/fieldtime_document_preparation.py's SUPPORTED_FIELDTIME_EXTENSIONS
// on the RAG side, which this client-side check mirrors as a fast/early
// signal only -- the server remains the authoritative validator). Shared by
// every upload entry point: the Upload dialog and Upload New Version.
export const SUPPORTED_EXTENSIONS = ['.pdf', '.docx'];
export const UNSUPPORTED_TYPE_MESSAGE =
  'Unsupported file type. Only .pdf and .docx are allowed.';

export function fileExtension(fileName) {
  const match = /\.[^./]+$/.exec(fileName || '');
  return match ? match[0].toLowerCase() : '';
}
